import { BasicState } from "@app/geography";
import { CountyLite } from "@app/geography/county";
import { ZipLite } from "@app/geography/zip";
import { RegionSetStatusType } from "@app/projects/enumerators";
import { CheckboxStateEnum } from "@app/shared/qes-standards/forms/Checkbox";

interface WithCheckboxState {
  checkboxState?: CheckboxStateEnum;
}

interface WithCountyStatus {
  countyStatus?: RegionSetStatusType;
}

export type EditorState = BasicState & WithCheckboxState;
// this is a little confusing because county checkboxes don't mean the county is part of the service area
// they're just used for the bulk county status dropdown
export type EditorCounty = CountyLite & WithCheckboxState & WithCountyStatus;
export type EditorZip = ZipLite & WithCheckboxState;

export const stateKey = "abbreviation";
export const countyKey = "countySSA";
export const zipKey = (countySSA: string, zipCode: string): string => {
  return `${countySSA}:${zipCode}`;
}
